export default __webpack_public_path__ + "static/media/10e202e99726f8256f572afd99b45a9.6ceb8f3b.png";